import { CommonModule } from "@angular/common";
import { Component, Renderer2 } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AppConfiguratorComponent } from "./app.configurator";
import { LayoutService } from "../service/layout.service";

@Component({
  selector: "app-empty-layout",
  standalone: true,
  imports: [CommonModule, RouterModule, AppConfiguratorComponent],
  template: `<div class="layout-container" [ngClass]="containerClass">
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
    <div class="layout-mask animate-fadein"></div>
    <app-configurator></app-configurator>
  </div> `,
})
export class AppEmptyLayoutComponent {
  constructor(
    public layoutService: LayoutService,
    public renderer: Renderer2,
    public router: Router,
  ) {}

  get containerClass() {
    const layoutConfig = this.layoutService.layoutConfig();
    const layoutState = this.layoutService.layoutState();

    return {
      "layout-light": !layoutConfig.darkTheme,
      "layout-dark": layoutConfig.darkTheme,
      "layout-colorscheme-menu": layoutConfig.menuTheme === "colorScheme",
      "layout-primarycolor-menu": layoutConfig.menuTheme === "primaryColor",
      "layout-transparent-menu": layoutConfig.menuTheme === "transparent",
      "layout-overlay": layoutConfig.menuMode === "overlay",
      "layout-static": layoutConfig.menuMode === "static",
      "layout-slim": layoutConfig.menuMode === "slim",
      "layout-slim-plus": layoutConfig.menuMode === "slim-plus",
      "layout-horizontal": layoutConfig.menuMode === "horizontal",
      "layout-reveal": layoutConfig.menuMode === "reveal",
      "layout-drawer": layoutConfig.menuMode === "drawer",
      "layout-static-inactive": layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === "static",
      "layout-overlay-active": layoutState.overlayMenuActive,
      "layout-mobile-active": layoutState.staticMenuMobileActive,
      "layout-sidebar-active": layoutState.sidebarActive,
      "layout-sidebar-anchored": layoutState.anchored,
    };
  }
}
